export enum SortAndFiltersViewType {
  FILTERS = 'FILTERS',
  SORT = 'SORT',
  SORT_AND_FILTERS = 'SORT_AND_FILTERS',
  APPLIED_FILTERS = 'APPLIED_FILTERS',
  FILTERS_PILLS = 'FILTERS_PILLS',
  SORT_TABS = 'SORT_TABS'
}
